import { Component, Input, OnInit } from '@angular/core';
import { GridCell } from '../../../models/sections-model';

@Component({
  selector: 'kw-product-identification',
  templateUrl: './product-identification.component.html',
  styleUrls: ['./product-identification.component.scss']
})
export class ProductIdentificationComponent implements OnInit {
  @Input() gridCell:GridCell;
  
  constructor() { }

  ngOnInit(): void {
    let productNameCnt = this.gridCell.contentElements.find(cntEl => cntEl.fieldName == "productName");
    let productIdCnt = this.gridCell.contentElements.find(cntEl => cntEl.fieldName == "productId");
    let brandNameCnt = this.gridCell.contentElements.find(cntEl => cntEl.fieldName == "brandName");
    let categoryNameCnt = this.gridCell.contentElements.find(cntEl => cntEl.fieldName == "categoryName"); 
    if(productNameCnt != undefined){
      productNameCnt?.classes.push("product-name")
    }
    if(productIdCnt != undefined){
      productIdCnt?.classes.push("product-id")
    }
    if(brandNameCnt != undefined){
      brandNameCnt?.classes?.push("brand-name")
    }
    if(categoryNameCnt != undefined){
      categoryNameCnt?.classes.push("category-name")
      categoryNameCnt?.classes.push("padding--top-zero")
    }
  }

}
